import * as ServerOnActions from './action';

const initialState = {
    serverOnDatesSuccess: {},
    serverOnDatesFailure: {}
}

const serverOnReducer = (state = initialState, action) => {
    switch (action.type) {
        case ServerOnActions.UPDATE_SERVER_ON_DATES_SUCCESS:
            return state = {
                ...state,
                serverOnDatesSuccess: action.data
            }
        case ServerOnActions.UPDATE_SERVER_ON_DATES_FAILURE:
            return state = {
                ...state,
                serverOnDatesFailure: action.data
            }
        default: return state
    }
};
export default serverOnReducer;